<template>
  <div class="container-wrap">
    <div class="top-tips">
      门店员工、学员关注公众号并完成登录后可以正常接收消息推送
    </div>
    <div class="table-header">
      <div class="td td1">模板消息</div>
      <div class="td td2">消息开关</div>
      <div class="td td3">推送规则</div>
      <div class="td td4">接收人员</div>
      <div class="td td5">跳转页面</div>
    </div>
    <div class="push-task-wrap" @click="toggleStaffListShow">
      <div class="title">员工消息</div>
      <div class="toggle-btn">
        <span>{{ staffListShow ? "收起" : "展开" }}</span>
        <i class="iconfont icon-a-cebianlanzhanshi" v-if="staffListShow"></i>
        <i class="iconfont icon-a-cebianlanshouqi" v-else></i>
      </div>
    </div>
    <div class="push-task-list mwow-table" v-show="staffListShow">
      <div class="row" v-for="(item, index) in staffData" :key="index">
        <div class="td td1">
          <div class="head">
            {{ item.wechat_template.name }}
            <div class="link">
              <el-popover
                placement="right"
                trigger="hover"
                :open-delay="100"
                :close-delay="100"
              >
                <div
                  class="preview-wrap"
                  :style="`background-image:url('https://wowsite.musicwow.com/teaching_system_frontend/images/approve/pushtask-bg.png')`"
                >
                  <div class="task-wrap">
                    <div class="dots">···</div>
                    <p class="title">
                      {{ item.wechat_template.content.title }}
                    </p>
                    <p class="desp">{{ item.wechat_template.content.first }}</p>
                    <div class="form">
                      <div
                        class="item"
                        v-for="(it, idx) in item.wechat_template.content.form"
                        :key="idx"
                      >
                        <span class="label">{{ it.key }}：</span>
                        <span class="value">{{ it.value }}</span>
                      </div>
                    </div>
                    <div class="foot">
                      <span class="text">查看详情</span>
                      <i class="iconfont icon-a-mianbaoxielanmu"></i>
                    </div>
                  </div>
                </div>
                <span slot="reference">预览模板</span>
              </el-popover>
            </div>
          </div>
          <p class="desp">{{ item.wechat_template.description }}</p>
        </div>
        <div class="td td2">
          <el-switch
            v-model="item.is_open"
            @change="handleChangeStatus(item)"
          ></el-switch>
        </div>
        <div
          class="td td3"
          v-html="item.wechat_template.rule.replace(/\r\n/, '<br/>')"
        ></div>
        <div class="td td4">{{ item.wechat_template.receive_object }}</div>
        <div class="td td5">{{ item.wechat_template.url_name }}</div>
      </div>
    </div>
    <div
      class="push-task-wrap"
      style="border-top: 0"
      @click="toggleStudentListShow"
    >
      <div class="title">学员消息</div>
      <div class="toggle-btn">
        <span>{{ studentListShow ? "收起" : "展开" }}</span>
        <i class="iconfont icon-a-cebianlanzhanshi" v-if="studentListShow"></i>
        <i class="iconfont icon-a-cebianlanshouqi" v-else></i>
      </div>
    </div>
    <div class="push-task-list mwow-table" v-show="studentListShow">
      <div class="row" v-for="(item, index) in studentData" :key="index">
        <div class="td td1">
          <div class="head">
            {{ item.wechat_template.name }}
            <div class="link">
              <el-popover
                placement="right"
                trigger="hover"
                :open-delay="100"
                :close-delay="100"
              >
                <div
                  class="preview-wrap"
                  :style="`background-image:url('https://wowsite.musicwow.com/teaching_system_frontend/images/approve/pushtask-bg.png')`"
                >
                  <div class="task-wrap">
                    <div class="dots">···</div>
                    <p class="title">
                      {{ item.wechat_template.content.title }}
                    </p>
                    <p class="desp">{{ item.wechat_template.content.first }}</p>
                    <div class="form">
                      <div
                        class="item"
                        v-for="(it, idx) in item.wechat_template.content.form"
                        :key="idx"
                      >
                        <span class="label">{{ it.key }}：</span>
                        <span class="value">{{ it.value }}</span>
                      </div>
                    </div>
                    <div class="foot">
                      <span class="text">查看详情</span>
                      <i class="iconfont icon-a-mianbaoxielanmu"></i>
                    </div>
                  </div>
                </div>
                <span slot="reference">预览模板</span>
              </el-popover>
            </div>
          </div>
          <p class="desp">{{ item.wechat_template.description }}</p>
        </div>
        <div class="td td2">
          <el-switch
            v-model="item.is_open"
            @change="handleChangeStatus(item)"
          ></el-switch>
        </div>
        <div
          class="td td3"
          v-html="item.wechat_template.rule.replace(/\r\n/, '<br/>')"
        ></div>
        <div class="td td4">{{ item.wechat_template.receive_object }}</div>
        <div class="td td5">{{ item.wechat_template.url_name || "-" }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getWechatTemplateApi, toggleTemplateApi } from "@/api/pushTask";
export default {
  props: ["visible"],
  data() {
    return {
      staffData: [],
      staffListShow: true,
      studentData: [],
      studentListShow: true,
    };
  },
  created() {
    // 单次watch页面展示，然后加载数据
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.init();
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    console.log(this.visible);
    if (this.visible) {
      this.init();
    }
  },
  methods: {
    init() {
      getWechatTemplateApi().then((res) => {
        res.data.staff.map((item) => {
          item.is_open = item.is_open === 1;
          item.wechat_template.content = JSON.parse(
            item.wechat_template.content
          );
        });
        res.data.student.map((item) => {
          item.is_open = item.is_open === 1;
          item.wechat_template.content = JSON.parse(
            item.wechat_template.content
          );
        });
        this.staffData = res.data.staff;
        this.studentData = res.data.student;
      });
    },
    toggleStaffListShow() {
      this.staffListShow = !this.staffListShow;
    },
    toggleStudentListShow() {
      this.studentListShow = !this.studentListShow;
    },
    handleChangeStatus(data) {
      toggleTemplateApi({
        template_message_id: data.template_message_id,
        is_open: data.is_open ? 1 : 2,
      })
        .then(() => {
          this.$message({
            type: "success",
            message: data.is_open ? "消息推送已开启" : "消息推送已关闭",
          });
          this.init();
        })
        .catch(() => {
          this.init();
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.container-wrap {
  padding: 12px;
}
.table-header {
  display: flex;
  border: 1px solid #e1e5e9;
  border-bottom: 0;
  .td {
    font-weight: 500;
    background-color: #f2f6fa;
    font-size: 12px;
    line-height: 42px;
    color: #5c5d5e;
    padding: 0 12px;
    &.td1 {
      flex: 2;
    }
    &.td2 {
      flex: 1;
    }
    &.td3 {
      flex: 2;
    }
    &.td4 {
      flex: 2;
    }
    &.td5 {
      flex: 2;
    }
  }
}
.push-task-wrap {
  height: 36px;
  color: #5c5d5e;
  line-height: 36px;
  display: flex;
  border: 1px solid #e1e5e9;
  padding: 0 12px;
  cursor: pointer;
  .title {
    flex: 1;
    font-size: 14px;
  }
  .toggle-btn {
    font-size: 12px;
    display: inline-flex;
    align-items: center;
    .iconfont {
      font-size: 18px;
    }
  }
}
.push-task-list {
  border: 1px solid #e1e5e9;
  border-top: 0;
  .row {
    display: flex;
    color: #5c5d5e;
    align-items: center;
    &:nth-child(2n + 1) {
      background-color: #f6fafc;
    }
    .td {
      padding: 12px;
      line-height: 18px;
      &.td1 {
        flex: 2;
        .link {
          color: #07d1aa;
          margin-left: 8px;
          cursor: pointer;
          display: inline-block;
        }
        .desp {
          color: #999999;
        }
      }
      &.td2 {
        flex: 1;
      }
      &.td3 {
        flex: 2;
      }
      &.td4 {
        flex: 2;
      }
      &.td5 {
        flex: 2;
      }
    }
  }
}
.top-tips {
  height: 28px;
  line-height: 28px;
  background: #fff7e9;
  border-radius: 4px;
  font-size: 12px;
  color: #5c5d5e;
  padding: 0 6px;
  display: inline-block;
  margin-bottom: 12px;
}
.preview-wrap {
  width: 375px;
  background-size: 100% auto;
  height: 519px;
  background-repeat: no-repeat;
  overflow: hidden;
  .task-wrap {
    background-color: #ffffff;
    padding: 12px 16px;
    border-radius: 8px;
    margin: 64px 14px 8px 14px;
    position: relative;
    .dots {
      position: absolute;
      top: 12px;
      right: 14px;
      font-weight: bolder;
      font-size: 16px;
    }
    .title {
      font-size: 14px;
      font-weight: 500;
      color: #000;
      margin-bottom: 12px;
    }
    .desp {
      font-size: 12px;
      margin-bottom: 24px;
    }
    .form {
      padding-bottom: 4px;
      .item {
        display: flex;
        margin-bottom: 12px;
        .label {
          width: 85px;
          font-size: 12px;
        }
        .value {
          flex: 1;
          font-size: 12px;
          color: #000;
        }
      }
    }
    .foot {
      display: flex;
      padding: 12px 14px 0 14px;
      border-top: 1px solid #eeeeee;
      margin: 0 -14px;
      .text {
        flex: 1;
        font-size: 12px;
        color: #000;
      }
      .iconfont {
      }
    }
  }
}
</style>
